import { render, staticRenderFns } from "./ModalEditVideoCat.vue?vue&type=template&id=413b2d5c&scoped=true&"
import script from "./ModalEditVideoCat.vue?vue&type=script&lang=js&"
export * from "./ModalEditVideoCat.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditVideoCat.vue?vue&type=style&index=0&id=413b2d5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b2d5c",
  null
  
)

export default component.exports